// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fbe550a1","160":"e9c89963","208":"843bc039","293":"df27fed4","453":"0909268a","516":"cbb5a71a","519":"8a70c9e3","917":"4734e76b","946":"262ce78c"}[chunkId] + ".chunk.js";
};